module.exports = __webpack_public_path__ + "593a3d53/img/google.68f3823e.svg";